export const AnalyticsKeys = {
    userId: 'userId',
};
